import type { BubblePlan, EducationalPlan } from '@innovamat/glow-api-client';
import { stages } from '@innovamat/radiance-utils';

import { useBubblePlans } from '../../../hooks/use-bubble-plans';
import { useEducationalPlans } from '../../../hooks/use-education-plans';

type Props = {
  courseOrder?: number;
  enabled?: boolean;
};

type PracticeLevelOptions = (EducationalPlan | BubblePlan)[];

function useStudentsPracticeLevel({ courseOrder, enabled = true }: Props) {
  const isSecundaria = !!stages.isSecundaria(courseOrder);

  const hasCourseOrder = Boolean(courseOrder);

  const shouldEnableEducationalRequest =
    (enabled && hasCourseOrder && isSecundaria) || (!hasCourseOrder && enabled);

  const shouldEnableBubbleRequest =
    (enabled && hasCourseOrder && !isSecundaria) ||
    (!hasCourseOrder && enabled);

  const { educationOptions, getEducationalPlanByCourse } = useEducationalPlans({
    filterOrderCourse: courseOrder,
    enabled: shouldEnableEducationalRequest,
  });

  const { bubblePlanOptions, getBubblePlanByCourse } = useBubblePlans({
    courseOrder,
    enabled: shouldEnableBubbleRequest,
  });

  const getPracticeLevelByCourse = (courseId: string) => {
    return {
      educationalPlan: isSecundaria
        ? getEducationalPlanByCourse(courseId)
        : null,
      bubblePlan: !isSecundaria ? getBubblePlanByCourse(courseId) : null,
    };
  };

  const practiceLevelOptions = [...educationOptions, ...bubblePlanOptions];

  return {
    practiceLevelOptions,
    getPracticeLevelByCourse,
  };
}

export { useStudentsPracticeLevel };
export type { PracticeLevelOptions };
